let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5zEOA")).then(() => parcelRequire('dQ2b1'));